import ResponsiveContentWrapper from "../components/layout/ResponsiveContentWrapper";
import InAppNotificationManagement from "../components/inAppNotificationManagement/InAppNotificationManagement";

const InAppNotificationPage = () => (
  <ResponsiveContentWrapper>
    <InAppNotificationManagement />
  </ResponsiveContentWrapper>
);

export default InAppNotificationPage;
